import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from '../../../../Notifications/ToastifyActions';


function PMGetPartnerCommentAttachmentByTicketIdService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/PMGetPartnerCommentAttachmentByTicketId`, data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Your ticket history fetched successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching comment and attachments. please try again later.");
        return false;
    });
}
    

export default PMGetPartnerCommentAttachmentByTicketIdService;